"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const serverFunctions_1 = require("../firebase/serverFunctions");
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const stringDecodeAsBase64_1 = __importDefault(require("./stringDecodeAsBase64"));
const stringEncodeAsBase64_1 = __importDefault(require("./stringEncodeAsBase64"));
const buildPreviewerAuthentication = ({ getLocalStorage, setLocalStorage, removeLocalStorage, getFirebaseFunctions, getFirebaseAuth, setAuthUserLocale, setAuthUser, setRendererCurrentUser, signInToFirebaseWithGoogle, signInToFirebaseWithFacebook, getI18nLocale, googleSignOut, }) => {
    const getAppToken = async (appId) => {
        const appTokensString = await getLocalStorage('sessiontokens:apps');
        if (!appTokensString)
            return undefined;
        const appTokens = JSON.parse(appTokensString);
        return appTokens[appId];
    };
    const saveClientAppTokenInPreviewer = async ({ appId }) => {
        const { customToken } = await (0, serverFunctions_1.rendererRequestLogAuth)(getFirebaseFunctions())();
        if (!customToken) {
            return;
        }
        const appTokensString = await getLocalStorage('sessiontokens:apps');
        const appTokens = JSON.parse(appTokensString || '{}');
        const newAppTokens = Object.assign(Object.assign({}, appTokens), { [appId]: (0, stringEncodeAsBase64_1.default)(customToken) });
        await setLocalStorage('sessiontokens:apps', JSON.stringify(newAppTokens));
    };
    const removeAppToken = async (appId) => {
        // Remove one app sessiontoken
        const appTokensString = await getLocalStorage('sessiontokens:apps');
        const appTokens = JSON.parse(appTokensString || '{}');
        delete appTokens[appId];
        await setLocalStorage('sessiontokens:apps', JSON.stringify(appTokens));
    };
    const finishRenderererLogin = async () => {
        const { currentUser } = getFirebaseAuth();
        if (currentUser) {
            const tokenResponse = await (0, serverFunctions_1.rendererRequestLogAuth)(getFirebaseFunctions())();
            if (tokenResponse.customToken) {
                await setLocalStorage('sessiontokens:main', (0, stringEncodeAsBase64_1.default)(tokenResponse.customToken));
            }
            setRendererCurrentUser(currentUser);
        }
        await setAuthUserLocale();
        return currentUser;
    };
    const loadMainAuthSession = async () => {
        if (getFirebaseAuth().currentUser) {
            await getFirebaseAuth().signOut();
        }
        try {
            const base64Token = await getLocalStorage('sessiontokens:main');
            if (base64Token) {
                await getFirebaseAuth().signInWithCustomToken((0, stringDecodeAsBase64_1.default)(base64Token));
            }
        }
        catch (_a) {
            if (getFirebaseAuth().currentUser) {
                await getFirebaseAuth().signOut();
            }
        }
        return finishRenderererLogin();
    };
    const loadApplicationSession = async (appId) => {
        try {
            const sessionToken = await getAppToken(appId);
            if (!sessionToken) {
                await getFirebaseAuth().signOut();
            }
            else {
                await getFirebaseAuth().signInWithCustomToken((0, stringDecodeAsBase64_1.default)(sessionToken));
            }
        }
        catch (error) {
            if (getFirebaseAuth().currentUser) {
                await getFirebaseAuth().signOut();
            }
        }
    };
    const rendererGoogleLogin = async () => {
        await signInToFirebaseWithGoogle();
        return finishRenderererLogin();
    };
    const rendererFacebookLogin = async () => {
        await signInToFirebaseWithFacebook();
        return finishRenderererLogin();
    };
    const rendererEmailLogin = async (email, password) => {
        await getFirebaseAuth().signInWithEmailAndPassword(email, password);
        return finishRenderererLogin();
    };
    const renderForgotPassword = async (email) => {
        await getFirebaseAuth().sendPasswordResetEmail(email);
    };
    const rendererEmailSignUp = async ({ name, email, password, phone, }) => {
        var _a;
        if (name.length < 4) {
            throw new Error('The name is invalid');
        }
        if (!email) {
            throw new Error('An email is required');
        }
        if (password.length < 6) {
            throw new Error('The password is invalid');
        }
        const response = await setAuthUser({
            name,
            email,
            password,
            phone,
            platform: 'mobile',
            typeLogIn: 'Email',
            locale: getI18nLocale(),
        });
        const authUserCreate = (0, getValueByPathFromUnknown_1.default)(response, ['data', 'authUserCreate']);
        if (!authUserCreate) {
            return null;
        }
        const user = await rendererEmailLogin(email, password);
        if (user) {
            await ((_a = user.sendEmailVerification) === null || _a === void 0 ? void 0 : _a.call(user));
        }
        return user;
    };
    const rendererLogOut = async () => {
        const sessionTokensApps = await getLocalStorage('sessiontokens:apps');
        if (sessionTokensApps) {
            await removeLocalStorage('sessiontokens:apps');
        }
        await removeLocalStorage('sessiontokens:main');
        try {
            await googleSignOut();
        }
        catch (error) {
            // error with google
        }
        await getFirebaseAuth().signOut();
    };
    return {
        saveClientAppTokenInPreviewer,
        removeAppToken,
        loadMainAuthSession,
        loadApplicationSession,
        rendererGoogleLogin,
        rendererFacebookLogin,
        rendererEmailLogin,
        renderForgotPassword,
        rendererEmailSignUp,
        rendererLogOut,
    };
};
exports.default = buildPreviewerAuthentication;
